
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { forgotPasswordApi } from "../../../../utils/apis/auth-service";

export const useForgotPasswordInsertCode = () => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const location = useLocation();
    const email = location.state?.email as string;
    const onBackButtonClick = async () => {
        navigate("/forgot-password")
    }

    const handleResendCode = async () => {
        forgotPasswordApi(
            email,
            async () => {
                navigate("/forgot-password-insert-code", { state: { email } })
            },
            async (error) => {
            }
        )
    }

    const handleInputSubmit = async (inputData: { [key: string]: string }) => {
        const code = inputData.code
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
            navigate("/new-password", { state: { email, code } })
        }, 1000)
    }

    return {
        onBackButtonClick,
        handleResendCode,
        handleInputSubmit,
        isLoading,
    }
}